import { render, staticRenderFns } from "./UpdatePatient.vue?vue&type=template&id=3f853242&"
import script from "./UpdatePatient.vue?vue&type=script&lang=js&"
export * from "./UpdatePatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports